"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
exports.UserAvatar = react_1.default.memo(function (_a) {
    var imageData = _a.imageData, name = _a.name, borderRadius = _a.borderRadius, width = _a.width;
    var classes = (0, styles_1.default)({ borderRadius: borderRadius, width: width });
    return ((0, jsx_runtime_1.jsx)("img", { src: "data:image/png;base64,".concat(imageData), alt: name, title: name, "data-testid": "user-avatar", className: classes.avatar }));
});
